import React from 'react'
import UIBody from '../../../components/ui/UIBody'
import { FaCheckCircle, FaUsers, FaCertificate, FaGlobe, FaArrowRight, FaDownload } from 'react-icons/fa';
import OtgStatsSection from './OtgStatsSection';
import OJTFeatures from './OJTFeatures';
import OtgForm from './OtgForm';
import OjtFaqSection from './OjtFaqsection';
import Ojtcarriersection from './Ojtcarriersection';
import OverlayLoader from '../../../components/Common/OverlayLoader';
import useApiCallHooks from '../../../hooks/useApiCallHooks';

const Otg = () => {
    const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  
  return (
    <UIBody
    content={<> 
      <OverlayLoader show={loading} />

    <div className="py-5 otg-bg" >

      <div className="container text-center">
        <p className="text-primary fw-semibold fs-5">
          <FaArrowRight className="me-2" />
          Now Accepting Applications for 2025
        </p>

        <h1 className="fw-bold text-dark display-4">
          Transform <span className="text-primary">Your Career</span> with
          <br />
          <span className="text-primary">On-the-Job Training</span>
        </h1>

        <p className="mt-4 text-secondary fs-5">
          Join India's premier OJT program and bridge the gap between academic learning and industry<br/> expertise.
          Get hands-on experience, mentorship from industry leaders, <br/>and guaranteed placement opportunities.
        </p>

        <div className="row justify-content-center mt-4">
          <div className="col-auto mt-2 mb-2">
            <div className="d-flex align-items-center bg-white shadow-sm px-4 py-2 rounded-pill">
              <FaCheckCircle className="text-success me-2" />
              <span>100% Placement Support</span>
            </div>
          </div>
          <div className="col-auto mb-2">
            <div className="d-flex align-items-center bg-white shadow-sm px-4 py-2 rounded-pill">
              <FaUsers className="text-primary me-2" />
              <span>5000+ Alumni Network</span>
            </div>
          </div>
          <div className="col-auto mb-2">
            <div className="d-flex align-items-center bg-white shadow-sm px-4 py-2 rounded-pill">
              <FaCertificate className="text-warning me-2" />
              <span>Industry Certified</span>
            </div>
          </div>
          <div className="col-auto mb-2">
            <div className="d-flex align-items-center bg-white shadow-sm px-4 py-2 rounded-pill">
              <FaGlobe className="text-danger me-2" />
              <span>Global Opportunities</span>
            </div>
          </div>
        </div>
        {/* <div className="mt-5 d-flex justify-content-center gap-4 flex-wrap">
          <button className="btn btn-primary btn-lg px-4">
            <FaArrowRight className="me-2" />
            Apply Now
          </button>
          <button className="btn btn-outline-primary btn-lg px-4">
            <FaDownload className="me-2" />
            Download Brochure
          </button>
        </div> */}
      </div>
    </div>
    <OtgStatsSection/>
    <OJTFeatures/>
    <OtgForm/>
    <OjtFaqSection/>
    <Ojtcarriersection/>
    </>
      
    }/>
  )
}

export default Otg
